module.exports = __webpack_public_path__ + "img/advance-market.97f68668.svg";